import { UserAllocation } from '@/types';

export function getMaxStoryPoints(userAllocations: UserAllocation[]): number {
  if (!userAllocations || userAllocations.length === 0) return 0;
  
  return Math.max(
    ...userAllocations.flatMap(user =>
      Object.values(user.sprints).map(sprint => sprint.storyPoints)
    ),
    0 // Ensure we return at least 0 if there are no story points
  );
}

interface ProjectTotals {
  total: number;
  completed: number;
}

export function getProjectTotals(projectKey: string, userAllocations: UserAllocation[] = []): ProjectTotals {
  let total = 0;
  let completed = 0;

  if (!userAllocations) return { total, completed };

  userAllocations.forEach(allocation => {
    Object.values(allocation.sprints).forEach(sprintData => {
      sprintData.issues.forEach(issue => {
        const issueProjectKey = issue.key.split('-')[0];
        if (issueProjectKey === projectKey && issue.storyPoints) {
          total += issue.storyPoints;
          if (issue.done) {
            completed += issue.storyPoints;
          }
        }
      });
    });
  });

  return { total, completed };
}

export function getUsersWithProject(projectKey: string, userAllocations: UserAllocation[] = []): Set<string> {
  const userIds = new Set<string>();
  
  if (!userAllocations) return userIds;
  
  userAllocations.forEach(allocation => {
    let hasProject = false;
    Object.values(allocation.sprints).forEach(sprintData => {
      sprintData.issues.forEach(issue => {
        const issueProjectKey = issue.key.split('-')[0];
        if (issueProjectKey === projectKey && issue.storyPoints) {
          hasProject = true;
        }
      });
    });
    
    if (hasProject) {
      userIds.add(allocation.user.id);
    }
  });
  
  return userIds;
}